import { CardHeader } from '@gogame/ui/Card';

import CommentActions from './CommentActions';

const CommentHeader = ({
  onEdit,
  onDelete,
  withActions,
  message: title,
  subheader,
  ...props
}) => (
  <CardHeader
    {...props}
    action={
      withActions ? (
        <CommentActions onEdit={onEdit} onDelete={onDelete} />
      ) : null
    }
    title={title}
    subheader={subheader}
  />
);
export default CommentHeader;
